import type { RentalObject } from '@modules/husleie-framework/src/types/RentalObject.entity';
import type { Tenant } from '@modules/husleie-framework/src/types/Tenant.entity';
import type { Subscription, SubscriptionCurrency } from '@modules/design-system/components/Subscription/Subscription.entity';
import { SubscriptionPaymentInterval } from '@modules/design-system/components/Subscription/Subscription.entity';

const enum TenancyStatus {
  FREE = 'free',
  ACTIVE = 'active',
}

interface Tenancy {
  id: string | number; // string when signed contract, number when tenancy, todo remove when the API is re-generated
  status: TenancyStatus;
  startDate: string;
  endDate?: string;
  tenants: Tenant[];
  rentalObjectId?: number;
  rentalObject?: Partial<RentalObject>;
  subscription?: {
    subscriptionPlanId: number;
    subscriptionPlanName: string;
    price: number;
    currency: SubscriptionCurrency;
    paymentInterval: SubscriptionPaymentInterval;
  };
  subscriptionPlans?: Subscription[];
}

interface TenancyLink {
  title: string;
  previewLink?: string;
  downloadLink?: string;
  creationLink?: string;
}

interface TenancyAndLinks extends Tenancy {
  links: TenancyLink[];
}

export { Tenancy, TenancyStatus, TenancyAndLinks, TenancyLink };
